import React from "react";

const WhyChooseUsSection = () => {
  return (
    <section className="section section-soft">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">Why Choose Us</p>
          <h2>Smart job search beats scattered job search.</h2>
        </div>
        <div className="comparison-grid">
          <section className="card comparison-card">
            <h3>Traditional Job Search</h3>
            <div className="check-grid">
              <span>Manual applications</span>
              <span>No follow-up system</span>
              <span>Resume mismatch risk</span>
              <span>Little visibility into progress</span>
            </div>
          </section>
          <section className="card comparison-card featured">
            <h3>Lovapex Tech</h3>
            <div className="check-grid">
              <span>Managed application engine</span>
              <span>Recruiter outreach</span>
              <span>ATS-ready resumes</span>
              <span>Weekly progress tracking</span>
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
